import styled, { css } from "styled-components";
import Flex from "../../Flex";
import { colorMixin } from "../../../helpers";

export const ClearButton = styled.button`
    align-items: center;
    background: transparent;
    border: unset;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0;
`;

export const List = styled(Flex)`
    list-style: "none";
    margin: 0;
    max-height: 150;
    overflow: auto;
    padding: 0;
`;

type ListItemProps = {
    $isFocused: boolean;
    $isSelected: boolean;
    $isDisabled: boolean;
};

export const ListItem = styled(Flex)`
    cursor: pointer;
    outline: none;

    ${({ $isDisabled, $isFocused, $isSelected }: ListItemProps) => {
        if ($isDisabled) {
            return css`
                background: ${colorMixin("background-primary-50")};
            `;
        }

        if ($isFocused) {
            return css`
                background: ${colorMixin("surface-50")};
            `;
        }

        if ($isSelected) {
            return css`
                background: ${colorMixin("surface-50")};
            `;
        }

        return "";
    }}
`;
